import { RotateCcw, ThumbsDown, Bookmark, ThumbsUp, Share } from "lucide-react";
import ButtonIcon from "@/components/buttons/button_icon";

// "Elevated white" action row: clean white pills with a deep, soft shadow and
// the colour carried in the icon (amber Undo, red Pass, orange Save, green
// Like, navy Share). Like and Pass are larger as the primary swipe actions.
// The bookmark SAVES the listing (never advances the deck); Share opens the
// native share sheet.
const BIG = "pointer-events-auto h-16 w-16 bg-white border-transparent shadow-[0_10px_24px_rgba(30,42,56,0.16)]";
const SMALL = "pointer-events-auto h-12 w-12 bg-white border-transparent shadow-[0_6px_16px_rgba(30,42,56,0.12)]";

export default function SwipeActions({ onUndo, onPass, onSave, saved = false, onLike, onShare = null, disabled = false }) {
  // pointer-events-auto on each button so the row works even when its wrapper
  // is pointer-events-none (the mobile overlay-over-card layout): the buttons
  // capture taps, the uncovered photo below stays draggable.
  const dim = disabled ? "pointer-events-none opacity-40" : "";
  return (
    <div className={`flex items-center justify-center gap-3 sm:gap-4 ${dim}`}>
      <ButtonIcon icon={RotateCcw} label="Undo last swipe" onClick={onUndo} size={20}
        className={`${SMALL} text-amber-500`} />
      <ButtonIcon icon={ThumbsDown} label="Pass" onClick={onPass} size={28}
        className={`${BIG} text-pass`} />
      <ButtonIcon
        icon={Bookmark}
        label="Save this home"
        aria-pressed={saved}
        onClick={onSave}
        size={20}
        className={`${SMALL} text-brand-primary`}
        iconClassName={saved ? "fill-brand-primary" : ""}
      />
      <ButtonIcon icon={ThumbsUp} label="Like" onClick={onLike} size={28}
        className={`${BIG} text-like`} />
      {onShare && (
        <ButtonIcon icon={Share} label="Share this home" onClick={onShare} size={20}
          className={`${SMALL} text-brand-ink`} />
      )}
    </div>
  );
}
